<template>
  <div class="w-full flex flex-col items-center">
    <div class=" mt-1 text-18px flex flex-row items-center ">
      <span class="flex-1 mr-1 invitation-code" v-if="label">{{label}}</span>
      <div class="flex-1">
        <otp-input
            :id="id"
            :isValid="isCodeValid"
            @on-complete="onCompleteHandler"
            @on-changed="onChangedHandler"
            @on-paste="onPasteHandler"
            @value="onValueChange"
            placeholder=""
            separateWrapperClass="separate-wrapper-class"
            separateInputClass="separate-input-class"
            :digits="digit"
        >
        </otp-input>
      </div>
    </div>
  </div>
</template>

<script>
import OtpInput from "@/components/common/OtpInput.vue";

export default {
  name: "OtpCode",
  components: { OtpInput },
  props: {

    id: {
      type: String,
      default: "otp",
    },
    label: {
      type:String,
      default: ""
    },
    digit: {
      type:Number,
      default:4
    }
  },
  data() {
    return {
      isCodeValid: false
    };
  },
  methods: {
    onCompleteHandler(code) {
      this.$emit("complete", code);
      console.log(`complete code: ${code}`);
    },

    onChangedHandler(lastEnteredCode) {
      console.log("code changed", lastEnteredCode);
    },

    onPasteHandler(code) {
      console.log("code pasted", code);
    },
    onValueChange(value) {
      console.log("code value", value);
      this.$emit('input',value)
    }

  }
};
</script>
<style scoped lang="less">

.vue-otp-input {
  //width: 100% !important;
}

.vue-otp-input ::v-deep .otp-wrapper {
  gap: unset !important;
  input {
    border: unset;
    border-bottom: solid 1px #e8e8e8 !important;
    padding: 0;
    color: #333333;
    margin-right:10px;
  }
}

.vue-otp-input ::v-deep .separate-input-class {
  text-align: center;
  font-weight: 600;
  border-bottom: solid 1px #e8e8e8;
  border-radius: 0rem !important;

  width: 30px;

  @media screen and (min-width: 390px) {
  }
  @media screen and (min-width: 449px) {
    //width: 64px;
    //height: 64px;
  }
}

.invitation-code {
  font-size: 16px;
  color: #333333;
  margin-right: 12px;
}

</style>